import {currentUserIsAdmin} from '@netx/core-permissions-next/enablers/currentUserIsAdmin';
import type {IAsset} from '../schema';

export const canUnlockAsset = (asset?: IAsset): boolean => {
	if (asset == null) return false;
	if (!currentUserIsAdmin()) return false;
	return asset.readOnly === 1;
};
